import { useTestShackReportDrawingPreviewQuery } from "@/pages/products/test-shack/hooks/queries/useTestShackReportDrawingPreviewQuery";
import { TestShackReportDrawingFrame } from "@/pages/products/test-shack/shared/components/report/TestShackReportDrawingFrame";
import type { TestShackReportSectionRev } from "../models/TestShackReportSectionRev";

interface TestShackReportDrawingPanelProps {
	sectionRev: TestShackReportSectionRev;
	onError: (error: Error) => void;
	onOpen: () => void;
}

// M1 shows only the mill drawing; M2 adds the dimensions reference toggle.
export const M1TestShackReportDrawingPanel = ({
	sectionRev,
	onError,
	onOpen,
}: TestShackReportDrawingPanelProps) => {
	const preview = useTestShackReportDrawingPreviewQuery({
		uploadFileId: sectionRev.millDrawingUploadFileId,
		onError,
	});

	return (
		<TestShackReportDrawingFrame
			sectionRev={sectionRev}
			label="Mill drawing"
			preview={sectionRev.millDrawingUploadFileId === null ? null : preview}
			onOpen={onOpen}
		/>
	);
};
